var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "recommend" }, [
    _c("div", { staticClass: "flex flex-between flex-middle" }, [
      _c("div", { staticClass: "switch-custom" }, [
        _c(
          "div",
          {
            class: {
              "switch-item": true,
              "switch-item-checked": _vm.index === 0,
            },
            on: {
              click: function ($event) {
                return _vm.changeIndex(0)
              },
            },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/image/aigc/douying.png"),
                alt: "",
              },
            }),
            _vm._v(" 抖音 "),
          ]
        ),
        _c(
          "div",
          {
            class: {
              "switch-item": true,
              "switch-item-checked": _vm.index === 1,
            },
            on: {
              click: function ($event) {
                return _vm.changeIndex(1)
              },
            },
          },
          [
            _c("img", {
              attrs: { src: require("@/assets/image/aigc/zhihu.png"), alt: "" },
            }),
            _vm._v(" 知乎 "),
          ]
        ),
      ]),
      _c("div", { staticClass: "time" }, [
        _vm._v(" 更新时间："),
        _c("span", [_vm._v(_vm._s(_vm.time || "-"))]),
      ]),
    ]),
    _c("div", { staticClass: "tabs" }, [
      _vm.index === 0
        ? _c(
            "div",
            { staticClass: "channel-types" },
            _vm._l(_vm.hotCategoryList, function (item, i) {
              return _c(
                "div",
                {
                  key: i,
                  class: {
                    "channel-item": true,
                    "channel-item-select ": item.checked,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.channelClick(item, i)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(item.name) + " ")]
              )
            }),
            0
          )
        : _vm._e(),
      _vm.index === 1
        ? _c("div", { staticClass: "channel-types" }, [
            _c(
              "div",
              {
                class: {
                  "channel-item": true,
                  "channel-item-select ": true,
                },
                on: {
                  click: function ($event) {
                    return _vm.channelClick(_vm.item, _vm.i)
                  },
                },
              },
              [_vm._v(" 热榜 ")]
            ),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "listRef",
          staticClass: "list",
          attrs: { "element-loading-spinner": "el-icon-loading" },
        },
        [
          _vm.list.length < 1
            ? _c("div", [_c("el-empty", { attrs: { "image-size": 200 } })], 1)
            : _vm._e(),
          _vm._l(_vm.list, function (item, i) {
            return _c("div", { key: i, staticClass: "item" }, [
              _c("div", { staticClass: "left" }, [
                _c(
                  "div",
                  {
                    staticClass: "title",
                    on: {
                      click: function ($event) {
                        return _vm.openUrl(item.linkUrl)
                      },
                    },
                  },
                  [
                    i == 0
                      ? _c("img", {
                          attrs: {
                            src: require("@/assets/image/aigc/hotone.png"),
                            alt: "",
                          },
                        })
                      : _vm._e(),
                    i == 1
                      ? _c("img", {
                          attrs: {
                            src: require("@/assets/image/aigc/hottowo.png"),
                            alt: "",
                          },
                        })
                      : _vm._e(),
                    i == 2
                      ? _c("img", {
                          attrs: {
                            src: require("@/assets/image/aigc/hotthree.png"),
                            alt: "",
                          },
                        })
                      : _vm._e(),
                    i > 2
                      ? _c("div", { staticClass: "sort-icon" }, [
                          _vm._v(_vm._s(i + 1)),
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(item.title) + " "),
                  ]
                ),
                _c("div", { staticClass: "desc" }, [
                  i < 3
                    ? _c("img", {
                        attrs: {
                          src: require("@/assets/image/aigc/hotpwtop.png"),
                          alt: "",
                        },
                      })
                    : _vm._e(),
                  _c("div", { staticStyle: { "padding-top": "6px" } }, [
                    _vm._v(" 热度："),
                    _c("span", [_vm._v(_vm._s(item.metrics))]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "operate" }, [
                _c(
                  "div",
                  {
                    staticClass: "btn-custom",
                    on: {
                      click: function ($event) {
                        return _vm.extractClick(item)
                      },
                    },
                  },
                  [
                    _vm._v(" 生成选题 "),
                    _c("img", {
                      staticClass: "img-right",
                      attrs: {
                        src: require("@/assets/image/aigc/right-icon.png"),
                        alt: "",
                      },
                    }),
                  ]
                ),
              ]),
            ])
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }